import { u as useStrings, b as useTypedDispatch, c as classNames, F as __awaiter, a3 as queueNotification } from './className-ac5eca03.js';
import React__default, { useId, Fragment } from 'react';
import { I as IconButton } from './Portal-a23febe1.js';

var faCopy = {};

var hasRequiredFaCopy;

function requireFaCopy () {
	if (hasRequiredFaCopy) return faCopy;
	hasRequiredFaCopy = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'copy';
		var width = 448;
		var height = 512;
		var ligatures = [];
		var unicode = 'f0c5';
		var svgPathData = 'M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faCopy = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faCopy));
	return faCopy;
}

var faCopyExports = requireFaCopy();

const DefinitionList = props => {
    const listId = useId();
    const { definitionList: definitionListStrings } = useStrings();
    const dispatch = useTypedDispatch();
    function renderDefinition(definition, index) {
        const id = `DefinitionList-${listId}-${index}`;
        const { value, name, dtClassName, ddClassName, copyToClipboard } = definition;
        if (!value && props.skipMissingValues) {
            return null;
        }
        const copyValueToClipboard = (key, value) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield navigator.clipboard.writeText(value);
                dispatch(queueNotification(definitionListStrings.copySuccess(key)));
            }
            catch (error) {
                dispatch(queueNotification(definitionListStrings.copyError));
            }
        });
        const copyBtnVisible = copyToClipboard && typeof name === 'string' && typeof value === 'string';
        return (React__default.createElement(Fragment, { key: id },
            React__default.createElement("dt", { id: id, className: classNames(dtClassName, { 'DefinitionList-btnVisible': copyBtnVisible }) }, name),
            React__default.createElement("div", { className: "DefinitionList-valueColumn" },
                React__default.createElement("dd", { "aria-labelledby": id, className: classNames(ddClassName, { 'DefinitionList-btnVisible': copyBtnVisible }) }, value !== null && value !== void 0 ? value : React__default.createElement("span", null, "\u2014")),
                copyBtnVisible && (React__default.createElement(IconButton, { icon: faCopyExports.faCopy, onClick: () => copyValueToClipboard(name, value), title: definitionListStrings.copyTitle(name) })))));
    }
    // https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/pull/807
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    return React__default.createElement("dl", { className: "DefinitionList", role: "list", "aria-label": props.label }, props.definitions.map(renderDefinition));
};

export { DefinitionList as D };
